import { Injectable } from '@angular/core';
import { Analytics, logEvent, setUserId } from '@angular/fire/analytics'; // Updated import path and class name, added logEvent, setUserId
import { environment } from 'src/environments/environment';
import { SharedService } from './shared.service';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {

  private analyticsEnabled: boolean;
  private appOpenSent: boolean;

  constructor(public analytics: Analytics, // Updated injected type
      private sharedService: SharedService) {
  }

  public logEvent(name: string, eventParams?: {[key: string]: any;}) {
    //logEvent(this.analytics, name, eventParams); // Use imported logEvent function
  }

  public setUserId(userId: string) {
    //setUserId(this.analytics, userId); // Use imported setUserId function
  }
}
